import { Button } from "@fluentui/react-components";
import { ChevronLeftRegular, ChevronRightRegular } from "@fluentui/react-icons";

interface TeamMembersPaginationProps {
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  isDisabled: boolean;
}

export const TeamMembersPagination = ({
  currentPage,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
  isDisabled,
}: TeamMembersPaginationProps) => (
  <div className="flex justify-center">
    <div className="flex items-center gap-3">
      <Button
        aria-label="Previous page"
        disabled={!hasPreviousPage || isDisabled}
        icon={<ChevronLeftRegular />}
        onClick={onPreviousPage}
        type="button"
      />
      <div className="text-bzd-gray-600 text-sm">Page {currentPage}</div>
      <Button
        aria-label="Next page"
        disabled={!hasNextPage || isDisabled}
        icon={<ChevronRightRegular />}
        onClick={onNextPage}
        type="button"
      />
    </div>
  </div>
);
